module.exports = __webpack_public_path__ + "dbe2c5bcaedc13afc4e12c8d7ea49c9f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/cover/cover-desktop.mp4
// module id = 259
// module chunks = 1